export default {
  "b2b.page-title.prehled": "Overview",
  "b2b.page-title.provozni-informace": "Operational Information",
  "b2b.page-title.provozni-informace.nova": "New Operational Information",
  "b2b.page-title.provozni-informace.editace": "Edit Operational Information",
  "b2b.page-title.provozni-informace.detail": "Detail Operational Information",
  "b2b.page-title.rezervace": "Reservations",
  "b2b.page-title.rezervace.historie": "Request History",
  "b2b.page-title.rezervace.odbaveni": "Request Handling",
  "b2b.page-title.rezervace.vytvoreni": "New Reservation",
  "b2b.page-title.rezervace.casovy-plan": "Timetable",
  "b2b.page-title.administrace": "Administration",
  "b2b.page-title.administrace.smlouva": "Contract",
  "b2b.page-title.administrace.projekt": "Project",
  "b2b.page-title.administrace.zakaznici": "Customers",
  "b2b.page-title.administrace.zdroje": "Resources"
};
